import { useEffect } from 'react';
import throttle from 'lodash.throttle';

export default function useMouseMaskAnimation(
  circleRef,
  inView,
  isTouchDevice
) {
  useEffect(() => {
    const mouseMove = (e) => {
      if (circleRef.current) {
        const maskPosition = `${e.clientX - 200}px ${e.clientY - 200}px`;

        circleRef.current.style['-webkit-mask-position'] = maskPosition;
        circleRef.current.style['mask-position'] = maskPosition;
      }
    };

    const throttleMouse = throttle(mouseMove, 30);

    if (inView && !isTouchDevice()) {
      window.addEventListener('mousemove', throttleMouse);
    }
    return () => {
      throttleMouse.cancel();
      window.removeEventListener('mousemove', throttleMouse);
    };
  }, [circleRef, inView, isTouchDevice]);
}
